import { getFontInfo } from './font-scale-handle';
/**
 * 字体缩放时触发事件
 * @param fontScale 缩放比例(和jsapi一样返回整数值，如： 放大1.1倍 返回110，实际使用时要除以100)
 */
export type FontScaleChanged = (fontScale: number) => void;

/**
 * 上报系统支持ResizeObserver特性情况
 * @param supportState 支持情况（0: 不支持；1:支持 2:修复后支持）
 */
function reportResizeObserverSupport(supportState: string) {
  console.log('resizeObserverSupport:', supportState);
}

/**
 * 字体缩放处理
 * 当使用结束时（如组件准备卸载）调用unobserve方法，提前销毁监听对象
 * @example
 * 初始化（可实时获取当前字体放大系数）：
 *  const observer = new FontScaleObserver((fontScale) => {
        console.log(fontScale);
    });
   销毁(使用后一定要记得调用下面的方便销毁当前监听动作)：
   observer.unobserve()
 */
export class FontScaleObserver {
  /** 参考元素 */
  refEl: HTMLElement | null = null;
  /** 监听DOM变化对象 */
  observer: ResizeObserver | null = null;
  /** 字体缩放触发的回调函数 */
  fontScaleChanged: FontScaleChanged;

  /**
   * 监听字体缩放
   * @param fontScaleChanged 字体缩放后的回调触发事件
   */
  constructor(fontScaleChanged: FontScaleChanged) {
    this.fontScaleChanged = fontScaleChanged;
    this.initFontScaleObserver();
  }

  /** 初始化监听DOM大小变化事件 */
  initFontScaleObserver() {
    if ('ResizeObserver' in window) {
      const refEl = this.getRefElement();
      const observer = new ResizeObserver(() => {
        this.fontScaleChanged(refEl.offsetHeight);
      });
      // 监听目标元素的大小变化
      observer.observe(refEl);
      this.refEl = refEl;
      this.observer = observer;
      reportResizeObserverSupport('1');
    } else {
      // 系统不支持的情况下通过webView获取页面进入时的字体放大系数
      // 对于后续用户在页面底部切换字体大小这种情况暂时放弃
      getFontInfo().then((res) => {
        if (res?.fontScale) {
          this.fontScaleChanged(res.fontScale);
          reportResizeObserverSupport('2');
        } else {
          this.fontScaleChanged(100);
          reportResizeObserverSupport('0');
        }
      });
    }
  }

  /**
         * 创建监听字体变化的参考元素
         * @returns
        */
  getRefElement(): HTMLElement {
    const id = 'js_font_scale_ref_el';
    const style = 'height: 100px; width: 0px; right: 0; bottom: 0; position: absolute; z-index: -1; opacity: 0; overflow: scroll; margin: 0px; padding: 0px;';
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('id', id);
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('style', style);
      el.innerHTML = '<div style="font-size:100px;line-height: 100px; margin: 0px; padding: 0px;">&nbsp;</div>';
      document.body.appendChild(el);
    }
    return el.querySelector('div')!;
  }

  /** 销毁监听动作*/
  unobserve() {
    const { observer, refEl } = this;
    if (observer && refEl) {
      observer.unobserve(refEl);
      observer.disconnect();
      this.observer = null;
      this.refEl = null;
    }
  }
}
